// React
import { useEffect, useState } from 'react'
// MainStem - UI
import { SelectSingle, useOnFirstLoad } from '@mainstem/react-mainstem'
import { ISelectOption } from '@mainstem/react-mainstem/dist/components/Form/Select/types'
// MainStem - API
import { Api } from 'api-new'
// Global - Components
import { LoaderSelect } from 'components/Loader'
// Local - Types
import { ISelectSingleProduct } from './types'

const mainStemApi = new Api()

const SelectSingleProduct: React.FC<ISelectSingleProduct> = ({
  defaultValue,
  label,
  onSelected,
  onlyPrivate = true,
  required,
  vendorId,
  vendorName
}: ISelectSingleProduct) => {
  // Loading Indicators
  const [loading, setLoading] = useState<boolean>(true)
  // View State
  const [options, setOptions] = useState<ISelectOption[] | undefined>(undefined)
  const [selectedValue, setSelectedValue] = useState<ISelectOption | undefined>(undefined)

  useEffect(() => {
    if (defaultValue && options) {
      const matchingValue = options.find((option) => option.value === defaultValue)
      setSelectedValue(matchingValue)
    }
  }, [defaultValue, options])

  useOnFirstLoad(() => {
    mainStemApi.api
      .productsList()
      .then((response) => {
        if (response.data.products) {
          const formattedOptions = response.data.products
            .filter((product) => {
              if (product.isDeleted) return false
              if (onlyPrivate && !product.isPrivate) return false
              if (vendorId == null && !vendorName) return true
              const matchesVendorId =
                vendorId != null && product.vendorID != null && Number(product.vendorID) === Number(vendorId)
              const matchesVendorName =
                !!vendorName &&
                !!product.vendorName &&
                product.vendorName.trim().toLowerCase() === vendorName.trim().toLowerCase()
              return matchesVendorId || matchesVendorName
            })
            .map((product) => {
              return {
                label: product.skuInternal ? `${product.name} (${product.skuInternal})` : product.name,
                value: product.id
              } as ISelectOption
            })

          setOptions(formattedOptions)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  })

  return (
    <>
      {loading || !options ? (
        <LoaderSelect label={label ? label : 'Select a product:'} />
      ) : (
        <SelectSingle
          isClearable={true}
          label={label ? label : 'Select a product:'}
          labelRequired={required}
          onChange={(newValue) => {
            setSelectedValue(newValue)
            onSelected(newValue)
          }}
          options={options}
          placeholder='Select a product'
          value={selectedValue}
        />
      )}
    </>
  )
}

export { SelectSingleProduct }
